<h2 mat-dialog-title class="dialog-header">{{ getDialogTitle() }}</h2>

<div mat-dialog-content>
  <!-- Add New Mode -->
  @if (currentMode === 'add-new') {
    <div class="create-form-content">
      <app-company-vote-proposal-name-form
        [form]="createForm"
        [isEditMode]="false"
        [hideActions]="true"
        (submit)="onCreateSubmit()">
      </app-company-vote-proposal-name-form>
    </div>
  }

  <!-- Search & Connect Mode (hidden instead of removed to preserve results) -->
  <div [hidden]="currentMode !== 'search-connect'">
    <ngx-spinner></ngx-spinner>
    <app-add-proposal-name-search
      (proposalNameSelected)="onProposalNameSelected($event)">
    </app-add-proposal-name-search>
  </div>
</div>

<div mat-dialog-actions class="dialog-actions">
  @if (currentMode === 'search-connect') {
    <button mat-raised-button color="primary" type="button" (click)="onAddNewFromSearch()">
      <mat-icon>add</mat-icon>
      Create New Proposal Name
    </button>
  }
  @if (currentMode === 'add-new') {
    <button mat-flat-button type="button" (click)="onBack()">
      <mat-icon>arrow_back</mat-icon>
      Back to Search
    </button>
  }
  <button mat-flat-button type="button" class="nrg-error-flat-button back-button" (click)="onCancel()">
    <mat-icon>clear</mat-icon>
    Cancel
  </button>
  @if (currentMode === 'add-new') {
    <button mat-flat-button color="primary" (click)="onCreateSubmit()"
            [disabled]="!createForm.valid">
      <mat-icon>save</mat-icon>
      Create Proposal Name
    </button>
  }
  @if (currentMode === 'search-connect') {
    <button mat-flat-button color="primary" (click)="onConfirmConnect()"
            [disabled]="!selectedItem">
      <mat-icon>person_add</mat-icon>
      Select Proposal Name
    </button>
  }
</div>
